var BillingDetails = /** @class */ (function () {
    function BillingDetails() {
        this._cards = [];
        this._subscriptions = [];
        // let sub = new BillingSubscription("Active");
        // sub.dateCanceled = new Date();
        // sub.dateRenewal = new Date();
        // sub.id = "Sub-1";
        // sub.name = "Discover and Change Membership";
        // sub.price = 2230;
        // sub.quantity = 77;
        // sub.unit = "Users";
        // this._subscriptions = [sub];
    }
    Object.defineProperty(BillingDetails.prototype, "subscriptions", {
        get: function () {
            return this._subscriptions;
        },
        set: function (v) {
            this._subscriptions = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingDetails.prototype, "email", {
        /**
         * Getter email
         * @return {string}
         */
        get: function () {
            return this._email;
        },
        /**
         * Setter email
         * @param {string} value
         */
        set: function (value) {
            this._email = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingDetails.prototype, "customerId", {
        /**
         * Getter customerId
         * @return {string}
         */
        get: function () {
            return this._customerId;
        },
        /**
         * Setter customerId
         * @param {string} value
         */
        set: function (value) {
            this._customerId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillingDetails.prototype, "cards", {
        /**
         * Getter cards
         * @return {BillingCard[]}
         */
        get: function () {
            return this._cards;
        },
        /**
         * Setter cards
         * @param {BillingCard[]} value
         */
        set: function (value) {
            this._cards = value;
        },
        enumerable: true,
        configurable: true
    });
    BillingDetails.prototype.hasCards = function () {
        return this.cards && this.cards.length > 0;
    };
    BillingDetails.prototype.hasSubscriptions = function () {
        return this.subscriptions && this.subscriptions.length > 0;
    };
    return BillingDetails;
}());
export { BillingDetails };



// WEBPACK FOOTER //
// ./src/app/shared/models/billing-details.ts.pre-build-optimizer.js